import React, { useMemo, useState } from "react";
import "./AddAction.less";
import { Dropdown } from "../../../BP2Components";
import { useIntl } from "react-intl";

function collectUsedFieldNames(node, acc = new Set()) {
   if (!node) return acc;

   if (Array.isArray(node)) {
      node.forEach((n) => collectUsedFieldNames(n, acc));
      return acc;
   }

   const source = node.modelField ?? node;
   const name = source.name;

   const isPrimitive = source.type?.isPrimitive;

   if (name && isPrimitive !== false && isPrimitive !== "false") {
      acc.add(String(name));
   }

   if (Array.isArray(node.items)) {
      collectUsedFieldNames(node.items, acc);
   }

   return acc;
}

const AddAction = ({ onAction, onlyFields = false, fields = [], fieldsUsed }) => {
   const intl = useIntl();
   const [isOpen, setIsOpen] = useState(false);

   const usedFieldNamesSet = useMemo(() => {
      const root = Array.isArray(fieldsUsed) ? fieldsUsed : [fieldsUsed];
      const acc = collectUsedFieldNames(root);
      return acc;
   }, [fieldsUsed]);

   const availableFieldOptions = useMemo(
      () =>
         fields
            .filter((field) => {
               const isUsed = usedFieldNamesSet.has(field.name);
               const isPrimitive = field?.type?.isPrimitive ?? field?.isPrimitive;

               return !(isUsed && isPrimitive === true);
            })
            .map((field) => ({
               id: field.name,
               action: "field",
               name: field.name,
            })),
      [fields, usedFieldNamesSet],
   );

   const elements = useMemo(
      () =>
         onlyFields
            ? []
            : [
                 {
                    id: "section",
                    action: "section",
                    name: intl.formatMessage({ id: "global.addSection" }),
                 },
                 {
                    id: "columns",
                    action: "columns",
                    name: intl.formatMessage({ id: "global.addTwoColumns" }),
                 },
                 {
                    id: "allFields",
                    action: "allFields",
                    name: intl.formatMessage({ id: "global.addAllFields" }),
                 },
                 {
                    id: "listTable",
                    action: "listTable",
                    name: intl.formatMessage({ id: "global.listTable" }),
                 },
              ],
      [onlyFields],
   );

   const items = useMemo(() => {
      if (onlyFields) return [...availableFieldOptions];
      if (availableFieldOptions.length === 0) return [...elements];
      return [...elements, { id: "separator", type: "separator" }, ...availableFieldOptions];
   }, [onlyFields, elements, availableFieldOptions]);

   const handleOptionClick = (item) => {
      if (!item || item.type === "separator") return;

      switch (item.action) {
         case "section":
            onAction("add", "section");
            break;
         case "columns":
            onAction("add", "columns");
            break;
         case "allFields":
            availableFieldOptions.forEach((opt) => onAction("add", opt.name));
            break;
         case "listTable":
            onAction("add", "listTable");
            break;
         default:
            onAction("add", item.name);
            break;
      }

      setIsOpen(false);
   };

   return (
      <div className="form-add-section">
         <button className="form-builder-action-btn" onClick={() => setIsOpen(true)}>
            +
         </button>
         <Dropdown
            items={items}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            className="processes-dropdown"
            onOptionClick={handleOptionClick}
         />
      </div>
   );
};

export default AddAction;
